import { Type } from "class-transformer";
import ResponseEntity from "../..";
import {
  IsBoolean,
  IsInt,
  IsString,
  ValidateIf,
  ValidateNested,
} from "class-validator";
import OutputLc from "../../lc";

export default class TransmedReceivingDetail extends ResponseEntity {
  @IsInt() public readonly id!: number;

  @Type(() => OutputLc)
  @ValidateNested()
  public readonly sender!: OutputLc;

  @Type(() => OutputLc)
  @ValidateNested()
  public readonly receiver!: OutputLc;

  @ValidateIf((obj) => obj.accomodation_yes !== null)
  @IsInt()
  public readonly accomodation_yes!: number | null;

  @ValidateIf((obj) => obj.accomodation_no !== null)
  @IsInt()
  public readonly accomodation_no!: number | null;
}

export class TransmedReceivingDetailWithProblems extends ResponseEntity {
  @IsInt() public readonly id!: number;

  @IsString() public readonly sender!: string;
  @IsString() public readonly receiver!: string;

  @ValidateIf((obj) => obj.accomodation_yes !== null)
  @IsInt()
  public readonly accomodation_yes!: number | null;

  @ValidateIf((obj) => obj.accomodation_no !== null)
  @IsInt()
  public readonly accomodation_no!: number | null;

  @IsBoolean() public readonly warning_yes!: boolean;
  @IsBoolean() public readonly warning_no!: boolean;
}
